import {useState, useEffect} from "react";
import {Layout, LayoutChild} from "../../../../../palette/Palette";
import Topology from "./Topology";
import Button from '@material-ui/core/Button';
import Seating from "./Seating";
import {FilterDelete, Filters, generateUUID, UpdateArray} from '../../../../../utils/HelpFunctions';
import format from 'date-fns/format';
import Text from "../../../../../palette/Text";
import hands from "../../../../../assets/img/hands.png"
import car from "../../../../../assets/img/car.png"
import {customScroll} from "../../../../../utils/Scroll";
import {Element} from 'react-scroll'

function AvailableSeats(props) {

    const {
        seating, columns, setDataList, dataList, selectedItemKeys, setSchemaType, schemaType,
        dataPassengers, setTotal, total, bookings, setBookings, getCoordsClient, valueDate, detailValue, setDetailValue,
        setCheckBoxValue, driverId, driver, vehicleData, availableSeats, photo,
        setAvailableSeats, providerPercentage, tripStartControl, tokenPush
    } = props;

    const [controlBaggage, setControlBaggage] = useState(null);
    const [visibleCheck, setVisibleCheck] = useState(false);
    const [cod, setCod] = useState('');

    useEffect(() => {
        if (seating) {
            let rows = [];
            let matrix = [];
            let count = 0;
            seating.forEach((items) => {
                count = count + 1;
                if (count <= columns - 1) {
                    if (items.reservation) {
                        items.color = 'green';
                    } else {
                        items.color = items.value ? '#00BFFF' : 'gray';
                    }

                    if (items.description === 'Chofer') {
                        items.value = false;
                        items.color = 'red';
                    }
                    rows.push(items);
                } else {
                    if (items.reservation) {
                        items.color = 'green';
                    } else {
                        items.color = items.value ? '#00BFFF' : 'gray';
                    }
                    if (items.description === 'Chofer') {
                        items.value = false;
                        items.color = 'red';
                    }
                    rows.push(items);
                    matrix.push(rows);
                    count = 0;
                    rows = [];
                }
            });
            setSchemaType(matrix);
            customScroll('bottom-element', 500)
        }

    }, [seating, columns]);

    /*useEffect(() => {
        const contactNumber = dataPassengers.contactNumber
        const filterDriver = Filters(bookings, 'driverId', driverId);
        if (filterDriver.length > 0) {
            const passengers = Filters(filterDriver[0].passengers, 'contactNumber', contactNumber);

            let detail;

            if (passengers.length > 1) {
                detail = passengers[passengers.length - 1].details
            } else {
                detail = passengers[0].details
            }


            if (detail === '') {
                setCheckBoxValue(false)
                setVisibleCheck(false)
            } else {
                setCheckBoxValue(true)
                setVisibleCheck(true)
            }
            setDetailValue(detail)
        } else {
            setDetailValue('')
            setCheckBoxValue(false)
            setVisibleCheck(false)
        }

    }, [driverId])*/

    useEffect(() => {
        const dateStr = format(valueDate, 'yyyy-MM-dd');
        const dateArray = dateStr.split('-')
        const num = Math.floor(Math.random() * 100) + 1
        const codPassenger = `${dateArray[1]}${dateArray[dateArray.length - 1]}${num.toString()}`
        setCod(codPassenger)
    }, [driverId, valueDate])


    const onClick = (key, i, value, check) => {
        if (check) {
            setVisibleCheck(true)
            let count = 0;
            let newDataArray = [...schemaType];
            const color = !value ? 'green' : '#00BFFF';

            newDataArray[i] = UpdateArray(newDataArray[i], 'description', key, 'reservation', !value);
            newDataArray[i] = UpdateArray(newDataArray[i], 'description', key, 'color', color);

            if (value) {
                newDataArray[i] = UpdateArray(newDataArray[i], 'description', key, 'name', '');
                newDataArray[i] = UpdateArray(newDataArray[i], 'description', key, 'cod', '');
            } else {
                newDataArray[i] = UpdateArray(newDataArray[i], 'description', key, 'name',
                    `${dataPassengers.name} ${dataPassengers.lastName}`);
                newDataArray[i] = UpdateArray(newDataArray[i], 'description', key, 'id',
                    `${dataPassengers.contactNumber}`);
                newDataArray[i] = UpdateArray(newDataArray[i], 'description', key, 'cod', cod);
            }

            newDataArray.forEach((row) => {
                const result = Filters(row, 'reservation', true);
                count = count + result.length;
            });

            setSchemaType(newDataArray);

            const docId = selectedItemKeys[0];

            const cost = vehicleData[0].rate + vehicleData[0].valueAdded;
            let totalCost = total;

            let seats;
            if (value) {
                setAvailableSeats(availableSeats + 1);
                seats = availableSeats + 1;
                totalCost = totalCost - cost;
            } else {
                setAvailableSeats(availableSeats - 1);
                seats = availableSeats - 1;
                totalCost = totalCost + cost;
            }

            setTotal(totalCost);
            const newDataSeating = [];

            newDataArray.forEach(items => {
                items.forEach(item => {
                    newDataSeating.push(item);
                });
            });

            const updateBooking = [...bookings];
            const bookingControl = Filters(updateBooking, 'driverId', driverId);

            if (total === 0) {
                setBookings([]);
            }

            if (updateBooking.length === 0 || bookingControl.length === 0) {
                let paymentValue = cost;
                setControlBaggage(paymentValue);
                paymentValue === 0 && setCheckBoxValue(false);

                const passengers = [{
                    cod: cod,
                    name: `${dataPassengers.name} ${dataPassengers.lastName}`,
                    paymentValue: paymentValue.toFixed(2),
                    contactNumber: dataPassengers.contactNumber,
                    coords: getCoordsClient,
                    paymentStatus: false,
                    passengerUid: null,
                    tokenPush: dataPassengers.tokenPush,
                    details: detailValue,
                    typeReservation: 'manual',
                }];

                let newDataPassenger = [];

                if (vehicleData[0].exists) {
                    newDataPassenger = [...vehicleData[0].passengers, ...passengers];
                } else {
                    newDataPassenger = passengers;
                }

                const travelStatusUid = generateUUID();

                console.log(vehicleData[0])

                const newObject = {
                    cod: cod,
                    availableSeats: seats,
                    date: format(valueDate, 'yyyy-MM-dd'),
                    driver: driver,
                    driverId: driverId,
                    photo: photo,
                    docId: vehicleData[0].exists ? vehicleData[0].docId : null,
                    travelStatusUid: vehicleData[0].exists ? vehicleData[0].travelStatusUid : travelStatusUid,
                    color: vehicleData[0].color,
                    brand: vehicleData[0].brand,
                    tripStartControl: tripStartControl,
                    providerPercentage: providerPercentage,
                    contactNumber: vehicleData[0].contactNumber,
                    exists: vehicleData[0].exists,
                    type_vehicle: vehicleData[0].type_vehicle,
                    valueAdded: vehicleData[0].valueAdded,
                    rate: vehicleData[0].rate,
                    tokenPush: vehicleData[0].tokenPush,
                    description: vehicleData[0].description,
                    columns: vehicleData[0].columns,
                    numberParcels: vehicleData[0].numberParcels,
                    commissionRate: vehicleData[0].commissionRate,
                    plateNumber: vehicleData[0].plateNumber,
                    routeName: vehicleData[0].routeName,
                    passengers: newDataPassenger,
                    seating: newDataSeating,
                    parcels: vehicleData[0].exists ? vehicleData[0].parcels : [],
                    type: 'programmed',
                    typeReservation: 'manual',
                    statusTrip: true,
                    baggage: false,
                };

                console.log(newObject)

                updateBooking.push(newObject);
                setBookings(updateBooking);
                if (paymentValue > 0) {
                    setBookings(updateBooking);
                }
            } else {

                const passengerName = `${dataPassengers.name} ${dataPassengers.lastName}`;
                const getPassenger = Filters(bookingControl[0].passengers, 'name', passengerName);

                let paymentValue;

                if (getPassenger.length > 1) {
                    paymentValue = getPassenger[getPassenger.length - 1].paymentValue
                } else {
                    paymentValue = getPassenger[0].paymentValue;
                }

                if (value) {
                    paymentValue = parseFloat(paymentValue) - cost;
                } else {
                    paymentValue = cost + parseFloat(paymentValue);
                }

                setControlBaggage(paymentValue);

                paymentValue === 0 && setCheckBoxValue(false);

                const passengers = [{
                    cod: cod,
                    name: `${dataPassengers.name} ${dataPassengers.lastName}`,
                    paymentValue: paymentValue.toFixed(2),
                    contactNumber: dataPassengers.contactNumber,
                    coords: getCoordsClient,
                    paymentStatus: false,
                    passengerUid: null,
                    tokenPush: dataPassengers.tokenPush,
                    details: detailValue,
                    typeReservation: 'manual',
                }];

                let newDataPassenger = [];

                if (vehicleData[0].exists) {
                    newDataPassenger = [...vehicleData[0].passengers, ...passengers];
                } else {
                    newDataPassenger = passengers;
                }

                const updateBookingPaymentValue = UpdateArray(updateBooking, 'driverId', driverId,
                    'passengers', newDataPassenger);

                const updateBookingAvailableSeats = UpdateArray(updateBookingPaymentValue, 'driverId', driverId,
                    'availableSeats', seats);

                const updateBookingArray = UpdateArray(updateBookingAvailableSeats, 'driverId', driverId, /*exists ? driverId : vehicleData[0].user_id*/
                    'seating', newDataSeating);


                if (paymentValue > 0) {
                    setBookings(updateBookingArray);
                } else {
                    const updateBookingArray = FilterDelete(updateBooking, 'driverId', driverId);
                    setBookings(updateBookingArray);
                }
            }

            let updateList;
            if (vehicleData[0].exists) {
                const available = UpdateArray(dataList, 'driverId', driverId, 'availableSeats', seats);
                updateList = UpdateArray(available, 'driverId', driverId, 'seating', newDataSeating);
            } else {
                const available = UpdateArray(dataList, 'driverId', docId, 'availableSeats', seats);
                updateList = UpdateArray(available, 'driverId', docId, 'seating', newDataSeating);
            }
            setDataList(updateList);
        }
    };

    return (
        <>
            <LayoutChild percent={100} padding={15} color={'#EEF4FD'}>
                <Text hover={false} text={`Vehículo de ${vehicleData[0].driver}`} size={16} weight={'700'}/>
            </LayoutChild>
            <Layout row center>
                <LayoutChild percent={40}>
                    <Topology/>
                </LayoutChild>
                <div className="car-container">
                    <div className="image-container">
                        <img src={car} alt={''} style={{width: '100%', height: 80}}/>
                        <span className="span-seating">Seleccionar asientos</span>
                    </div>

                    {schemaType.map((items, i) => {
                        return (
                            <Layout row space key={i} positionC center>
                                {items.map((item, index) => {
                                    return (
                                        <div className="seating-container" key={index}>
                                            <LayoutChild center>
                                                {item.description === 'Chofer' &&
                                                <img src={hands} alt={''} style={{width: 45, height: 45}}/>}
                                                <Button disableElevation style={{width: 40, height: 40}}
                                                        onClick={() => onClick(item.description, i, item.reservation, item.value)}
                                                >
                                                    <Seating text={item.description}
                                                             color={item.description === 'Chofer' ? 'red' :
                                                                 item.value === false ? '#90A4AE' : item.color}
                                                             seatColor={item.description === 'Chofer' ? '#FFF2BF' :
                                                                 item.value === false ? '#B0BEC5' : '#FFF2BF'}
                                                             textColor={'black'}/>
                                                </Button>
                                                <Text size={9} text={item.name} weight={'bold'}/>
                                            </LayoutChild>
                                        </div>
                                    )
                                })}
                            </Layout>
                        )
                    })}
                </div>
            </Layout>
            <Element name="bottom-element" className="element"/>
        </>
    )
}

export default AvailableSeats
